import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Banner2 from "../../../assets/images/banner/fob.png";
import Banner3 from "../../../assets/images/banner/abb.png";
import Banner4 from "../../../assets/images/banner/iab.png";
import Banner5 from "../../../assets/images/banner/atb.png";
import Banner6 from "../../../assets/images/banner/gob.png";
import Banner7 from "../../../assets/images/banner/cbb.png";

const heroSlides = [
  { image: Banner2, price: "From SGD 100/month", link: "/wa-food-ordering" },
  {
    image: Banner3, price: "From SGD 100/month", link: "/wa-appointment-booking",
  },
  { image: Banner4, price: "From SGD 100/month", link: "/wa-invoice" },
  { image: Banner5, price: "From SGD 100/month", link: "/wa-attendance" },
  { image: Banner6, price: "From SGD 100/month", link: "/wa-grocery-ordering" },
  {
    image: Banner7,
    price: "From SGD 100/month",
    link: "/wa-chatbot",
  },
];

const HomeHeroSlider = () => {
  const [activeHeroIndex, setActiveHeroIndex] = useState(-1);

  const goNextHero = () => {
    setActiveHeroIndex((prev) => (prev + 1) % heroSlides.length);
  };

  const goPrevHero = () => {
    setActiveHeroIndex(
      (prev) => (prev - 1 + heroSlides.length) % heroSlides.length,
    );
  };

  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setActiveHeroIndex(0);
    }, 100);

    const heroTimer = setInterval(() => {
      setActiveHeroIndex((prev) => {
        if (prev === -1) return 0;
        return (prev + 1) % heroSlides.length;
      });
    }, 5000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(heroTimer);
    };
  }, []);

  const currentHero =
    activeHeroIndex >= 0 ? heroSlides[activeHeroIndex] : heroSlides[0];

  return (
    <section className="siw-hero-slider-wrapper">
      {heroSlides.map((slide, index) => (
        <div
          key={index}
          className={`siw-hero-slide-bg ${
            index === activeHeroIndex ? "siw-hero-slide-active" : ""
          }`}
          style={{ backgroundImage: `url(${slide.image})` }}
          aria-hidden="true"
        />
      ))}

      <button
        className="siw-hero-nav-btn siw-hero-prev-btn no-cursor-effect"
        onClick={goPrevHero}
      >
        ‹
      </button>

      <button
        className="siw-hero-nav-btn siw-hero-next-btn no-cursor-effect"
        onClick={goNextHero}
      >
        ›
      </button>

      <div className="siw-hero-content-area p_relative">
        <div className="auto-container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <div className="siw-hero-content-box" key={activeHeroIndex}>
                {currentHero.title && <h1>{currentHero.title}</h1>}

                {currentHero.price && currentHero.link && (
                  <div className="siw-hero-price-box">
                    <h3>{currentHero.price}</h3>

                    <Link
                      to={currentHero.link}
                      className="theme-btn theme-btn-one siw-hero-small-btn"
                    >
                      View Details
                    </Link>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-5 col-md-12"></div>
          </div>

          <div className="siw-hero-dots">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                className={
                  index === activeHeroIndex ? "siw-hero-dot-active" : ""
                }
                onClick={() => setActiveHeroIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHeroSlider;
